import { PERMISSIONS } from '@/generated/permissions'

export const estimateRoutes = [
  {
    component: () =>
      import('@/domains/accounting/estimates/pages/IndexPage.vue'),
    meta: {
      anyPerm: [
        PERMISSIONS.ESTIMATE_READ,
        PERMISSIONS.ESTIMATE_CREATE,
        PERMISSIONS.ESTIMATE_UPDATE,
        PERMISSIONS.ESTIMATE_DELETE,
        PERMISSIONS.ESTIMATE_SEND,
      ],
      requiresAuth: true,
      requiresQuickBooks: true,
    },
    name: 'estimates-index',
    path: '/estimates',
  },
  {
    component: () => import('@/domains/accounting/estimates/pages/NewPage.vue'),
    meta: {
      anyPerm: [PERMISSIONS.ESTIMATE_CREATE],
      requiresAuth: true,
      requiresQuickBooks: true,
    },
    name: 'estimates-new',
    path: '/estimates/new',
  },
  {
    component: () =>
      import('@/domains/accounting/estimates/pages/DetailPage.vue'),
    meta: {
      anyPerm: [PERMISSIONS.ESTIMATE_READ],
      requiresAuth: true,
      requiresQuickBooks: true,
    },
    name: 'estimates-detail',
    path: '/estimates/:id',
  },
]
